<span *ngIf="disabledTooltip() !== null; else trigger"
      class="xp-menu-select__tooltip"
      [matTooltip]="disabledTooltip() ?? ''"
      [matTooltipDisabled]="!disabled()">
	<ng-container *ngTemplateOutlet="trigger"></ng-container>
</span>
<ng-template #trigger>
	<button xpButton
	        type="button"
	        class="xp-menu-select__button"
	        [variant]="variant()"
	        [disabled]="disabled()"
	        [attr.aria-label]="ariaLabel()"
	        [matMenuTriggerFor]="menu">
		<mat-icon *ngIf="icon() && iconPosition() === 'start'">{{ icon() }}</mat-icon>
		<span class="xp-menu-select__label">{{ label() }}</span>
		<mat-icon *ngIf="icon() && iconPosition() === 'end'">{{ icon() }}</mat-icon>
	</button>
</ng-template>
<mat-menu #menu="matMenu">
	<button *ngFor="let option of options()"
	        mat-menu-item
	        type="button"
	        (click)="optionSelected.emit(option.value)">
		<mat-icon *ngIf="option.icon">{{ option.icon }}</mat-icon>
		{{ option.label }}
	</button>
</mat-menu>
